<template>
  <div class="relative border border-grey-200 bg-white p-6 rounded">
    <p class="text-xs font-bold uppercase text-grey-700">
      {{ item.created_by }} says:
    </p>
    <p class="text-sm">
      Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione repudiandae cum quas in, esse sapiente distinctio velit aspernatur deserunt amet aut mollitia. Corporis.
    </p>
  </div>
</template>

<script>
export default {
  name: 'LogListItemMessage',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
}
</script>